import { defineStore } from 'pinia';

export const useSyncQueueStore = defineStore('syncQueue', {
    state: () => ({
        pendingCountsByLocation: {} as Record<string, number>,
        showNavigationWarning: false,
        navigationOverrideEnabled: false,
    }),
    getters: {
        totalPendingCount(state): number {
            // @ts-ignore
            return Object.values(state.pendingCountsByLocation).reduce((sum, c) => sum + c, 0);
        },
        hasPendingSyncs(): boolean {
            return this.totalPendingCount > 0;
        },
    },
    actions: {
        increment(locationId: string) {
            this.navigationOverrideEnabled = false;
            if (this.pendingCountsByLocation[locationId] == null) {
                this.pendingCountsByLocation = {
                    ...this.pendingCountsByLocation,
                    [locationId]: 0,
                };
            }
            this.pendingCountsByLocation[locationId]++;
        },
        decrement(locationId: string) {
            if (this.pendingCountsByLocation[locationId] != null) {
                this.pendingCountsByLocation[locationId]--;
                if (this.pendingCountsByLocation[locationId] <= 0) {
                    delete this.pendingCountsByLocation[locationId];
                }
            }
        },
        clearLocation(locationId: string) {
            delete this.pendingCountsByLocation[locationId];
        },
        enableNavigationOverride() {
            this.navigationOverrideEnabled = true;
        },
    },
});
